module.exports = __webpack_public_path__ + "static/media/cbc-radio-canada-white.34948396.svg";